// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__2ixMZ","small":"button_small__2AXLB","medium":"button_medium__2mdJR","large":"button_large__2JdH5","disabled":"button_disabled__OePrh"};